import { DsButtonBase } from "../DsButtonBase/DsButtonBase"
import { DsButtonsType } from "../DsButtonsTypes"

export type DsButtonDestructiveProps = DsButtonsType

export function DsButtonDestructive(props: DsButtonDestructiveProps) {
  return <DsButtonBase {...props} color="red" variant="outline" />
}
